<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="23" height="23">
    <path d="M0 0h24v24H0z" fill="none"/>
    <path d="M7 10l5 5 5-5z"/>
  </svg>
</template>
